export const CLASSES = [
  "Nursery",
  "LKG",
  "UKG",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
];

export const SAMPLE_EVENTS = [
  {
    id: 1,
    title: "Nursery Sports Day",
    class: "Nursery",
    category: "Sports",
    date: "2026-02-12",
    images: ["/images/placeholder1.jpg"],
    content: "A fun-filled day of races and games for our youngest learners.",
  },
  {
    id: 2,
    title: "LKG Art Week",
    class: "LKG",
    category: "Arts",
    date: "2026-02-20",
    images: ["/images/placeholder2.jpg"],
    content: "Students showcased colourful paintings and craftwork.",
  },
  {
    id: 3,
    title: "UKG Annual Day",
    class: "UKG",
    category: "Cultural",
    date: "2026-03-01",
    images: ["/images/placeholder3.jpg"],
    content: "Performances by students celebrating achievements.",
  },
  {
    id: 4,
    title: "Class 1 Picnic",
    class: "1",
    category: "Outing",
    date: "2026-03-10",
    images: ["/images/placeholder4.jpg"],
    content: "A short picnic trip providing outdoor learning experiences.",
  },
  {
    id: 5,
    title: "Class 5 Science Fair",
    class: "5",
    category: "Academic",
    date: "2026-03-22",
    images: ["/images/placeholder5.jpg"],
    content: "Projects and demonstrations by students showcasing science.",
  },
  {
    id: 6,
    title: "Class 10 Farewell",
    class: "10",
    category: "Other",
    date: "2026-04-05",
    images: ["/images/placeholder6.jpg"],
    content: "A heartfelt farewell ceremony celebrating the graduating class.",
  },
];

export const OTHER_CATEGORIES = [
  "Sports",
  "Arts",
  "Cultural",
  "Academic",
  "Outing",
  "Other",
];
